module.exports = __webpack_public_path__ + "static/img/ywc.c0bc86f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ywc.png
// module id = xFa6
// module chunks = 1